import Fetch, { V1, V3 } from 'Util/fetcher';

//= =================================================================================//
//                        GET BURSA TIME FOR TRADING                                 //
//= =================================================================================//

const ON_REQUEST_GET_TRADING_TIME = 'ON_REQUEST_GET_TRADING_TIME';
const ON_REQUEST_GET_TRADING_TIME_FAILURE = 'ON_REQUEST_GET_TRADING_TIME_FAILURE';
const ON_REQUEST_GET_TRADING_TIME_SUCCESS = 'ON_REQUEST_GET_TRADING_TIME_SUCCESS';

function onRequestGetTradingTime() {
  return {
    type: ON_REQUEST_GET_TRADING_TIME,
  };
}

function onRequestGetTradingTimeSuccess(payload) {
  return {
    type: ON_REQUEST_GET_TRADING_TIME_SUCCESS,
    payload,
  };
}

function onRequestGetTradingTimeFailure(payload) {
  return {
    type: ON_REQUEST_GET_TRADING_TIME_FAILURE,
    payload,
  };
}

export const onDoRequestGetTradingTime = () => (dispatch) => {
  dispatch(onRequestGetTradingTime());
  Fetch.get(`${V1}stock/data/trading-day/time/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestGetTradingTimeSuccess(resp.json));
      } else {
        dispatch(onRequestGetTradingTimeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestGetTradingTimeFailure(error.message));
    });
};

//= =================================================================================//
//                        CREATE ORDER FOR BUY STOCK                                 //
//= =================================================================================//

const ON_CREATE_BUY_STOCK = 'ON_CREATE_BUY_STOCK';
const ON_CREATE_BUY_STOCK_SUCCESS = 'ON_CREATE_BUY_STOCK_SUCCESS';
const ON_CREATE_BUY_STOCK_FAILURE = 'ON_CREATE_BUY_STOCK_FAILURE';
const ON_RESET_BUY = 'ON_RESET_BUY';

function onCreateBuyStock() {
  return {
    type: ON_CREATE_BUY_STOCK,
  };
}

function onCreateBuyStockSuccess(payload) {
  return {
    type: ON_CREATE_BUY_STOCK_SUCCESS,
    payload,
  };
}

function onCreateBuyStockFailure(payload) {
  return {
    type: ON_CREATE_BUY_STOCK_FAILURE,
    payload,
  };
}

function onResetBuy() {
  return {
    type: ON_RESET_BUY,
  };
}

export const onDoCreateBuyStock =
  (payload, isTransactionPage = false) =>
  (dispatch) => {
    dispatch(onCreateBuyStock());
    Fetch.post(`${V1}stock/buy/`, payload)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onCreateBuyStockSuccess(resp.json));
          if (isTransactionPage) {
            window.location.reload();
          }
        } else {
          dispatch(onCreateBuyStockFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onCreateBuyStockFailure(error.message));
      });
  };

export const onDoResetBuy = () => (dispatch) => {
  dispatch(onResetBuy());
};

//= =================================================================================//
//                              CREATE ORDER FOR SELL STOCK                          //
//= =================================================================================//

const ON_CREATE_SELL_STOCK = 'ON_CREATE_SELL_STOCK';
const ON_CREATE_SELL_STOCK_SUCCESS = 'ON_CREATE_SELL_STOCK_SUCCESS';
const ON_CREATE_SELL_STOCK_FAILURE = 'ON_CREATE_SELL_STOCK_FAILURE';
const ON_RESET_SELL = 'ON_RESET_SELL';

function onCreateSellStock() {
  return {
    type: ON_CREATE_SELL_STOCK,
  };
}

function onCreateSellStockSuccess(payload) {
  return {
    type: ON_CREATE_SELL_STOCK_SUCCESS,
    payload,
  };
}

function onCreateSellStockFailure(payload) {
  return {
    type: ON_CREATE_SELL_STOCK_FAILURE,
    payload,
  };
}

function onResetSell() {
  return {
    type: ON_RESET_SELL,
  };
}

export const onDoCreateSellStock =
  (payload, isTransactionPage = false) =>
  (dispatch) => {
    dispatch(onCreateSellStock());
    Fetch.post(`${V1}stock/sell/`, payload)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onCreateSellStockSuccess(resp.json));
          if (isTransactionPage) {
            window.location.reload();
          }
        } else {
          dispatch(onCreateSellStockFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onCreateSellStockFailure(error.message));
      });
  };
export const onDoResetSell = () => (dispatch) => {
  dispatch(onResetSell());
};
//= =================================================================================//
//                   SEARCH STOCK TICKER CODE                                        //
//= =================================================================================//

const ON_SEARCH_STOCK = 'ON_SEARCH_STOCK';
const ON_SEARCH_STOCK_SUCCESS = 'ON_SEARCH_STOCK_SUCCESS';
const ON_SEARCH_STOCK_FAILURE = 'ON_SEARCH_STOCK_FAILURE';

function onSearchStock() {
  return {
    type: ON_SEARCH_STOCK,
  };
}

function onSearchStockSuccess(payload) {
  return {
    type: ON_SEARCH_STOCK_SUCCESS,
    payload,
  };
}

function onSearchStockFailure(payload) {
  return {
    type: ON_SEARCH_STOCK_FAILURE,
    payload,
  };
}

export const onDoSearchStock = (payload) => (dispatch) => {
  dispatch(onSearchStock());
  Fetch.get(`${V1}stock/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onSearchStockSuccess(resp.json));
      } else {
        dispatch(onSearchStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onSearchStockFailure(error.message));
    });
};

//= =================================================================================//
//                     GET API FOR LIST PORTFOLIO STOCK                              //
//= =================================================================================//

const ON_PORTFOLIO_STOCK = 'ON_PORTFOLIO_STOCK';
const ON_PORTFOLIO_STOCK_SUCCESS = 'ON_PORTFOLIO_STOCK_SUCCESS';
const ON_PORTFOLIO_STOCK_FAILURE = 'ON_PORTFOLIO_STOCK_FAILURE';

function onPortfolioStock() {
  return {
    type: ON_PORTFOLIO_STOCK,
  };
}

function onPortfolioStockSuccess(payload) {
  return {
    type: ON_PORTFOLIO_STOCK_SUCCESS,
    payload,
  };
}

function onPortfolioStockFailure(payload) {
  return {
    type: ON_PORTFOLIO_STOCK_FAILURE,
    payload,
  };
}

export const onDoPortfolioStock = () => (dispatch) => {
  Fetch.get(`${V3}stock/portfolio/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onPortfolioStockSuccess(resp.json?.result));
      } else {
        dispatch(onPortfolioStockFailure(resp.json?.result));
      }
    })
    .catch((error) => {
      dispatch(onPortfolioStockFailure(error.message));
    });
};

//= =================================================================================//
//                                  GET API FOR MARKET INDEX                         //
//= =================================================================================//

const ON_REQUEST_MARKET_INDEX = 'ON_REQUEST_MARKET_INDEX';
const ON_REQUEST_MARKET_INDEX_FAILURE = 'ON_REQUEST_MARKET_INDEX_FAILURE';
const ON_REQUEST_MARKET_INDEX_SUCCESS = 'ON_REQUEST_MARKET_INDEX_SUCCESS';

function onRequestMarketIndex(vendorCode) {
  return {
    type: ON_REQUEST_MARKET_INDEX,
    meta: { vendorCode },
  };
}

function onRequestMarketIndexSuccess(vendorCode, payload) {
  return {
    type: ON_REQUEST_MARKET_INDEX_SUCCESS,
    payload,
    meta: { vendorCode },
  };
}

function onRequestMarketIndexFailure(vendorCode, payload) {
  return {
    type: ON_REQUEST_MARKET_INDEX_FAILURE,
    payload,
    meta: { vendorCode },
  };
}

export const onDoRequestMarketIndex = (vendorCode) => (dispatch) => {
  dispatch(onRequestMarketIndex(vendorCode.toLowerCase()));
  Fetch.get(`${V1}stock/market_index/detail/${vendorCode}/price/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestMarketIndexSuccess(vendorCode.toLowerCase(), resp.json));
      } else {
        dispatch(onRequestMarketIndexFailure(vendorCode.toLowerCase(), resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestMarketIndexFailure(vendorCode.toLowerCase(), error.message));
    });
};

export const onUpdateDetailStockData = (payload) => ({
  type: 'UPDATE_DETAIL_STOCK_DATA',
  payload,
});

const INITIAL_STATE = {
  tradingTime: null,
  tradingTimeLoading: null,
  tradingTimeError: null,
  createStockBuy: null,
  createStockBuySuccess: null,
  createStockBuyError: null,
  searchStock: null,
  searchStockData: null,
  searchStockError: null,
  portfolioStock: null,
  portfolioStockData: null,
  portfolioStockError: null,
  createStockSell: null,
  createStockSellSuccess: null,
  createStockSellError: null,

  marketIndex: {
    composite: {
      loading: false,
      data: null,
      error: null,
    },
  },
  detailStockDataTrading: null,
};

const stock = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_GET_TRADING_TIME:
      return {
        ...state,
        tradingTimeLoading: true,
        tradingTime: null,
        tradingTimeError: null,
      };
    case ON_REQUEST_GET_TRADING_TIME_SUCCESS:
      return {
        ...state,
        tradingTimeLoading: false,
        tradingTime: action.payload,
        tradingTimeError: null,
      };
    case ON_REQUEST_GET_TRADING_TIME_FAILURE:
      return {
        ...state,
        tradingTimeLoading: false,
        tradingTime: null,
        tradingTimeError: action.payload,
      };

    case ON_CREATE_BUY_STOCK:
      return {
        ...state,
        createStockBuy: true,
        createStockBuySuccess: null,
        createStockBuyError: null,
      };
    case ON_CREATE_BUY_STOCK_SUCCESS:
      return {
        ...state,
        createStockBuy: true,
        createStockBuySuccess: action.payload,
        createStockBuyError: null,
      };
    case ON_CREATE_BUY_STOCK_FAILURE:
      return {
        ...state,
        createStockBuy: true,
        createStockBuySuccess: null,
        createStockBuyError: action.payload,
      };

    case ON_SEARCH_STOCK:
      return {
        ...state,
        searchStock: true,
        searchStockData: null,
        searchStockError: null,
      };
    case ON_SEARCH_STOCK_SUCCESS:
      return {
        ...state,
        searchStock: true,
        searchStockData: action.payload,
        searchStockError: null,
      };
    case ON_SEARCH_STOCK_FAILURE:
      return {
        ...state,
        searchStock: true,
        searchStockData: null,
        searchStockError: action.payload,
      };

    case ON_PORTFOLIO_STOCK:
      return {
        ...state,
        portfolioStock: true,
        portfolioStockData: null,
        portfolioStockError: null,
      };
    case ON_PORTFOLIO_STOCK_SUCCESS:
      return {
        ...state,
        portfolioStock: true,
        portfolioStockData: action.payload,
        portfolioStockError: null,
      };
    case ON_PORTFOLIO_STOCK_FAILURE:
      return {
        ...state,
        portfolioStock: true,
        portfolioStockData: null,
        portfolioStockError: action.payload,
      };

    case ON_CREATE_SELL_STOCK:
      return {
        ...state,
        createStockSell: true,
        createStockSellSuccess: null,
        createStockSellError: null,
      };
    case ON_CREATE_SELL_STOCK_SUCCESS:
      return {
        ...state,
        createStockSell: true,
        createStockSellSuccess: action.payload,
        createStockSellError: null,
      };
    case ON_CREATE_SELL_STOCK_FAILURE:
      return {
        ...state,
        createStockSell: true,
        createStockSellSuccess: null,
        createStockSellError: action.payload,
      };

    case ON_REQUEST_MARKET_INDEX:
      return {
        ...state,
        marketIndex: {
          ...state.marketIndex,
          [action.meta.vendorCode]: {
            ...state.marketIndex[action.meta.vendorCode],
            loading: true,
            error: null,
          },
        },
      };
    case ON_REQUEST_MARKET_INDEX_FAILURE:
      return {
        ...state,
        marketIndex: {
          ...state.marketIndex,
          [action.meta.vendorCode]: {
            ...state.marketIndex[action.meta.vendorCode],
            loading: false,
            error: action.payload,
          },
        },
      };
    case ON_REQUEST_MARKET_INDEX_SUCCESS:
      return {
        ...state,
        marketIndex: {
          ...state.marketIndex,
          [action.meta.vendorCode]: {
            loading: false,
            data: action.payload,
            error: null,
          },
        },
      };
    case 'UPDATE_DETAIL_STOCK_DATA':
      return {
        ...state,
        detailStockDataTrading: action.payload,
      };

    case 'ON_RESET_BUY':
      return {
        ...state,

        createStockBuy: null,
        createStockBuySuccess: null,
        createStockBuyError: null,
      };

    case 'ON_RESET_SELL':
      return {
        ...state,

        createStockSell: null,
        createStockSellSuccess: null,
        createStockSellError: null,
      };
    default:
      return state;
  }
};

export default stock;
